export default __webpack_public_path__ + "static/sm-poster2-87f1581a3821257af7c893e0048ddc17.png";